// src/utils/auth.js
import { Message } from 'element-ui'
import request from '@/utils/request'

class AuthService {
  constructor() {
    this.token = localStorage.getItem('token')
    this.refreshToken = localStorage.getItem('refreshToken')
    this.user = JSON.parse(localStorage.getItem('user') || 'null')
  }

  async login(loginForm) {
    // try {
      const response = await request.post('/auth/login', loginForm)
      
      if (response.code == 200) {
        const { accessToken, refreshToken, user } = response.data
        
        this.token = accessToken
        this.refreshToken = refreshToken
        this.user = user
        
        localStorage.setItem('token', accessToken)
        localStorage.setItem('refreshToken', refreshToken)
        localStorage.setItem('user', JSON.stringify(user))
        
        Message.success('登录成功')
        return true
      } else {
        Message.error(response.msg || '登录失败')
        return false
      }
    // } catch (error) {
    //   Message.error(error.response?.data?.message || '登录失败')
    //   return false
    // }
  }

  async logout() {
        try {
            // 调用后端退出接口
            await request.post('/auth/logout')
        } catch (error) {
            console.log('退出接口调用失败:', error)
            // 即使后端调用失败，也要清理前端状态
        } finally {
            // 清理本地存储
            this.token = null
            this.refreshToken = null
            this.user = null
            
            localStorage.removeItem('token')
            localStorage.removeItem('refreshToken')
            localStorage.removeItem('user')
            //await this.$store.dispatch('tab/resetTabsOnLogout');
            localStorage.removeItem('visitedTabs')
            Message.success('已退出登录')
            // // 跳转到登录页
            // window.location.href = '/login'
            // 跳转到登录页
            const loginPath = '/login'
            const currentPath = window.location.pathname
            
            // 如果当前不是登录页，跳转到登录页并携带返回地址
            if (currentPath !== loginPath) {
              const returnUrl = encodeURIComponent(currentPath + window.location.search)
              window.location.href = `${loginPath}?redirect=${returnUrl}`
            }
        }
  }

  async changePassword(passwordData) {
    try {
      const response = await request.post('/auth/change-password', passwordData)
      if (response.data.success) {
        Message.success('密码修改成功')
        return true
      }
    } catch (error) {
      Message.error(error.response?.data?.message || '密码修改失败')
      return false
    }
  }

  async applyTenant(tenantData) {
    try {
      const response = await request.post('/tenant/apply', tenantData)
      if (response.data.success) {
        Message.success('租户申请已提交，请等待审核')
        return true
      }
    } catch (error) {
      Message.error(error.response?.data?.message || '租户申请失败')
      return false
    }
  }

  isAuthenticated() {
    return !!this.token && !!this.user
  }

  hasRole(role) {
    return this.user?.roles?.includes(role)
  }

  hasPermission(permission) {
    return this.user?.permissions?.includes(permission)
  }

  getCurrentUser() {
    return this.user
  }

  getToken() {
    return this.token
  }
}

export default new AuthService()